import client from './client';

export const getAppInsightsKey = async () => client.get('/configuration/appInsightsInstrumentationKey').then((response) => response.data);

export const getFeatureFlags = async () => client.get('/configuration/featureFlags').then((response) => response.data);

export const getUserRoles = async () => client.get('/user/roles').then((res) => res.data);
